// Аккордион в подвале
document.addEventListener('DOMContentLoaded', () => {
  const coll = document.querySelectorAll('.collapsible') ?? []

  coll.forEach((el) => {
    el.addEventListener('click', () => {
      el.classList.toggle('active')
      const content = el.nextElementSibling
      if (content.style.maxHeight) {
        content.classList.remove('content-active')
      } else {
        content.classList.toggle('content-active')
      }
    })
  })

  $('.wrapper').on('click', 'fixed-menu a', function (event) {
    event.preventDefault()
    var id = $(this).attr('href'),
      top = $(id).offset().top
    $('body,html').animate({ scrollTop: top }, 1500)
  })

  window.onscroll = function () {
    const sections = document.querySelectorAll('.section--full')
    const fixedMenuItems = document.querySelectorAll('.fixed-menu li')

    sections.forEach(function (section, i) {
      if (section.getBoundingClientRect().top <= window.innerHeight / 2) {
        fixedMenuItems.forEach((item) => item.classList.remove('active'))
        fixedMenuItems[i].classList.add('active')
      }
    })
  }
})
